export default {"src":"/_next/static/media/TextIndent.06df8bb2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};